import React, {useState, useEffect} from "react";
import Accordion from "../../components/accordion/Accordion";
import {cleanDrops} from "../../hooks/helpers";
import ImgEncabezado from "../../components/imagenEncabezado/ImgEncabezado";
import PrimeList from "./components/CoursesList";
import MasterclassList from "./components/MasterclassList";


export default function CertificatePrimeView({theme}) {
   const [status, setStatus] = useState([0, 0]);
   const [isLoading, setLoading] = useState({data: true, all: false});
   const [data, setData] = useState([]);

   useEffect(() => {
      let dataN = [...datExample];
      setData(dataN);
      setLoading({...isLoading, data: false});
   }, []);

   const changeMode = (newVal, key) => {
      let nStatus = cleanDrops(status.length, key, newVal);
      setStatus([...nStatus]);
   };

   return (
      <>
         <ImgEncabezado
            theme={theme}
            title="Imagenes encabezado para certicado prime"
            status={status[0]}
            changeMode={val => changeMode(val, 0)}
            titleDesc="Descripción general de Certificado Prime"
            idUpdate={2}
            nameUpdate="Prime"
            linkWeb="certificado_prime"
         />
         <Accordion theme={theme} title="lista de certificado prime" status={status[1]} changeMode={val => changeMode(val, 1)}>
            <PrimeList theme={theme} isLoading={isLoading.data} data={data} />
         </Accordion> 
         <Accordion theme={theme} title="lista de certificado masterclass" status={status[2]} changeMode={val => changeMode(val, 2)}>
            <MasterclassList theme={theme} isLoading={isLoading.data} data={data} />
         </Accordion>
      </>
   );
}

const datExample = [
   {
      id: 1,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
      hours: "3 horas",
   },
   {
      id: 2,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: true,
      onhome: true,
      hours: "3 horas",
   },
   {
      id: 4,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
      hours: "3 horas",
   },
   {
      id: 6,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: false,
      onhome: false,
      hours: "3 horas",
   },
   {
      id: 8,
      name: "Nombre del curso",
      facilitator: "Nombre de los expositores",
      code: "aA8i2",
      date: "12/05/2020",
      onpage: true,
      onhome: false,
      hours: "3 horas",
   },
];
